// extracted by mini-css-extract-plugin
export default {"componentIconTitle":"ComponentTitle_componentIconTitle__Nw7-q"};